export default __webpack_public_path__ + "static/media/possibility_4.714afa8a.png";